export default __webpack_public_path__ + "static/media/love2.b94367bc.jpg";